var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5625 3.68481V1.78125C3.5625 1.4535 3.2965 1.1875 2.96875 1.1875C2.641 1.1875 2.375 1.4535 2.375 1.78125V5.34375C2.375 5.6715 2.641 5.9375 2.96875 5.9375H6.53125C6.859 5.9375 7.125 5.6715 7.125 5.34375C7.125 5.016 6.859 4.75 6.53125 4.75H4.19128C5.49634 3.29294 7.39159 2.375 9.5 2.375C13.4324 2.375 16.625 5.56759 16.625 9.5C16.625 13.4324 13.4324 16.625 9.5 16.625C5.56759 16.625 2.375 13.4324 2.375 9.5C2.375 9.17225 2.109 8.90625 1.78125 8.90625C1.4535 8.90625 1.1875 9.17225 1.1875 9.5C1.1875 14.0879 4.91209 17.8125 9.5 17.8125C14.0879 17.8125 17.8125 14.0879 17.8125 9.5C17.8125 4.91209 14.0879 1.1875 9.5 1.1875C7.17488 1.1875 5.07181 2.14403 3.5625 3.68481ZM8.90625 4.75V8.90625C8.90625 9.89009 9.70366 10.6875 10.6875 10.6875H13.0625C13.3903 10.6875 13.6562 10.4215 13.6562 10.0938C13.6562 9.766 13.3903 9.5 13.0625 9.5H10.6875C10.3597 9.5 10.0938 9.234 10.0938 8.90625C10.0938 7.33162 10.0938 4.75 10.0938 4.75C10.0938 4.42225 9.82775 4.15625 9.5 4.15625C9.17225 4.15625 8.90625 4.42225 8.90625 4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteThree);
export default __webpack_public_path__ + "static/media/route-three.d9e665ab2ec95511d8b39b166fb8d9a0.svg";
export { ForwardRef as ReactComponent };